import { render, staticRenderFns } from "./SurgeryDelete.vue?vue&type=template&id=91925e5c&scoped=true&"
import script from "./SurgeryDelete.vue?vue&type=script&lang=js&"
export * from "./SurgeryDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91925e5c",
  null
  
)

export default component.exports